import { FC } from 'react';
import styled, { DefaultTheme, IntrinsicElementsKeys, StyledComponent } from 'styled-components';

type AlignmentTypes = 'center' | 'flex-start' | 'flex-end' | 'stretch' | 'baseline';

interface IAligned {
	alignItems?: AlignmentTypes;
	justifyContent?: AlignmentTypes;
	alignSelf?: AlignmentTypes;
	justifySelf?: AlignmentTypes;
}

const aligned = <U>(
	component: StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys
) =>
	styled<StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys>(
		component
	)<IAligned>`
		align-items: ${({ alignItems }) => !!alignItems && alignItems};
		align-self: ${({ alignSelf }) => !!alignSelf && alignSelf};
		justify-content: ${({ justifyContent }) => !!justifyContent && justifyContent};
		justify-self: ${({ justifySelf }) => !!justifySelf && justifySelf};
	`;

export default aligned;
